export default __webpack_public_path__ + "static/media/policy-prototyping-cover.a62f2f90.png";